import useSubmitStore from "stores/submit"
import { AppInterface } from "types/types"
import AppsListItem from "./AppsListItem"
import { Virtuoso } from "react-virtuoso"

interface Props {
  title?: string
  apps?: AppInterface[]
}

const AppsList = ({ title, apps }: Props) => {
  const setStep = useSubmitStore((state) => state.setStep)
  const Step = useSubmitStore((state) => state.step)
  return (
    <div>
      <div className="card card-style">
        <div className="content mb-0">
          {title && (
            <h2 className="font-18 font-600 color-highlight pb-3 text-center">
              {Step > 0 && (
                <i
                  onClick={() => setStep(0)}
                  className="fa fa-arrow-left float-start"
                ></i>
              )}
              {title}
            </h2>
          )}
          <div
            className="apps-list-container"
            style={{ display: apps?.length === 1 ? "block" : "grid" }}
          >
            <Virtuoso
              useWindowScroll
              data={apps}
              overscan={400}
              itemContent={(index, app) => (
                <div className="list-item">
                  <AppsListItem app={app} />
                  {apps && apps.length > 1 && apps[index + 1] !== undefined && (
                    <div className="divider mb-0 d-block"></div>
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppsList
